import { createDomainListReduxUtil } from '../../../redux/utils'
import { EXERCISES_KEY } from './key'

export * from './domain'
export * from './key'
export * from './path'

const EXERCISES_STATE = {
  [EXERCISES_KEY.CURRENT]: null,
  [EXERCISES_KEY.DATA]: {},
  [EXERCISES_KEY.TYPE_TO_IDS]: {},
  [EXERCISES_KEY.MUSCLE_TO_IDS]: {},
  [EXERCISES_KEY.BY_QUERY]: {},
  [EXERCISES_KEY.ALL]: createDomainListReduxUtil(),
  [EXERCISES_KEY.CREATED]: createDomainListReduxUtil()
}

const EXERCISES_ENDPOINT = {
  EXERCISES: '/exercises',
  EXERCISE_BY_ID: '/exercise/:id',
  UPLOAD_IMAGE: '/exercise/upload-image/:id',
  UPLOAD_VIDEO: '/exercise/upload-video/:id'
}

const EXERCISES_ACTION = {
  CREATE: 'EXERCISES_CREATE',
  UPDATE_CURRENT: 'EXERCISES_UPDATE_CURRENT',
  SAVE: 'EXERCISES_SAVE',
  LOAD: 'EXERCISES_LOAD',
  LOAD_BY_ID: 'EXERCISES_LOAD_BY_ID'
}

export {
  EXERCISES_ACTION,
  EXERCISES_STATE,
  EXERCISES_ENDPOINT
}
